export default "__VITE_ASSET__DYSJyOSn__"